import React, { Component } from 'react'
import { connect } from 'react-redux'
import { SchoolInformationActions } from '../../../../../../store'
import { MuiGrid } from '../../../../../ui'
import { UnjoinClassesComponent } from './'
import { updatingRulesUtil } from '../../../updatingRulesUtil'
import lodashUtil from 'lodash'
import { ConstraintsAndPreferences, CalculateUtil } from '..';
import { UnjoinClassUtil } from './'

class UnjoinClassesContainer extends Component {
	constructor(props) {
		super(props)
		this.state = {

		}
	}

	onClickOfSave = async () => {
		let dataTableMap = this.props.dataTableMap
		let keys = this.props.keys
		let scheduleConstraintsObj = JSON.parse(JSON.stringify(this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex]));
		let gradeArray = []
		for (let i = 0; i < keys.length; i++) {
			let key = keys[i]
			let dataObj = dataTableMap.get(key)
			if (dataObj.jointClass != undefined) {
				delete dataObj.bgColor
				UnjoinClassUtil.deletingRules(scheduleConstraintsObj, dataObj)
				// deleting the grade Obj
				if (!gradeArray.includes(dataObj.grade)) {
					gradeArray.push(dataObj.grade)
					UnjoinClassUtil.deleteingParticulrGradeObject(scheduleConstraintsObj, dataObj)
				}
			}
		}
		UnjoinClassUtil.updatingTheRulesCount(scheduleConstraintsObj)
		await this.props.updateDialogSave(scheduleConstraintsObj);
		this.props.handleCloseForDialog();
		this.props.handleClose();
	}

	render() {
		return (
			<MuiGrid>
				<UnjoinClassesComponent
					{...this.props}
					{...this.state}
					onClickOfSave={this.onClickOfSave}
				/>
			</MuiGrid>

		)
	}
}

const mapStateToProps = (state, ownProps) => ({
	updateSchoolinformationInProgress: state.schoolInformation.updateSchoolinformationInProgress,
})
const mapDispatchToProps = (dispatch) => ({
	editSchoolInformation: (ownerId, schoolId, data) => dispatch(SchoolInformationActions.editSchoolInformation(ownerId, schoolId, data))
});

export default connect(mapStateToProps, mapDispatchToProps)(UnjoinClassesContainer)